// Use the API to sign Content-Disposition=attachment; cross-origin <a download>
// is ignored by browsers and fetching the public audio requires CORS.
export function recordingDownloadUrl(fileUrl, apiBaseUrl) {
  if (!fileUrl) return '';
  try {
    const parts = new URL(fileUrl).pathname.split('/').filter(Boolean);
    if (parts.length !== 2) return '';
    const key = parts.map((part) => encodeURIComponent(decodeURIComponent(part))).join('/');
    return `${apiBaseUrl.replace(/\/$/, '')}/recordings/${key}?download=1`;
  } catch {
    return '';
  }
}
